import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

export const getQuestionnaires = (params = {}) =>
  axios.get(`${BASE}/getquestionnaires`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      search: params.search,
      kecamatan: params.kecamatan,
      desaKelurahan: params.desaKelurahan,
    },
  });

export const getQuestionnaireById = (id) =>
  axios.get(`${BASE}/getquestionnaires/${id}`);

export const createQuestionnaire = (payload) =>
  axios.post(`${BASE}/createquestionnaires`, payload);

export const updateQuestionnaire = (id, formData) =>
  axios.put(`${BASE}/updatequestionnaires/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteQuestionnaire = (id) =>
  axios.delete(`${BASE}/delete/${id}`);

export const deleteQuestionnaireByDesa = (desaKelurahan) =>
  axios.delete(`${BASE}/questionnaires/desa/${desaKelurahan}`);

export const filterQuestionnaires = (params = {}) =>
  axios.get(`${BASE}/filter`, { params });

export const downloadExcel = () =>
  axios.get(`${BASE}/download`, { responseType: 'blob' });

export const getStatusRumah = () =>
  axios.get(`${BASE}/statusrumah`);

export const getStatusRumah2 = () =>
  axios.get(`${BASE}/statusrumah2`);

export const getDatabacklog = () =>
  axios.get(`${BASE}/backlog`);

export const getAllQuestionnaires = () =>
  axios.get(`${BASE}/all`);

export const initializeStats = () =>
  axios.post(`${BASE}/sinkron`);

export const DataAll = () =>
  axios.get(`${BASE}/dataall`);

export const updateverifikasiBantuan = (id, payload) =>
  axios.put(`${BASE}/updateverifikasibantuan/${id}`, payload);

export default {
  getQuestionnaires,
  getQuestionnaireById,
  createQuestionnaire,
  updateQuestionnaire,
  deleteQuestionnaire,
  deleteQuestionnaireByDesa,
  filterQuestionnaires,
  downloadExcel,
  getStatusRumah,
  getStatusRumah2,
  getDatabacklog,
  getAllQuestionnaires,
  initializeStats,
  DataAll,
  updateverifikasiBantuan,
};
